export default class ScrollAnchorLink {
  constructor() {
    this.headerHeight = () => ($('#header').height() || 0)
  }

  scrollToTarget(hash) {
    const $target = $(hash)
    if (!$target.length || $target.hasClass('no-scroll-anchor')) return
    $('html, body').animate(
      { scrollTop: $target.offset().top - this.headerHeight() },
      800,
    )
  }

  init() {
    const syncScrollPadding = () => {
      document.documentElement.style.scrollPaddingTop = `${this.headerHeight()}px`
    }
    syncScrollPadding()
    $(window).on('resize orientationchange', syncScrollPadding)

    // All anchor links — no class restriction
    $(document).on('click', 'a[href^="#"]', (event) => {
      const hash = $(event.currentTarget).attr('href')
      if (!hash || hash === '#') return
      if (!$(hash).length) return
      event.preventDefault()
      this.scrollToTarget(hash)
    })

    // On page load: scroll if URL has a hash matching an existing element
    $(window).on('load', () => {
      syncScrollPadding()
      const { hash } = window.location
      if (hash) {
        this.scrollToTarget(hash)
      }
    })
  }
}

new ScrollAnchorLink().init()
